module.exports = __webpack_public_path__ + "img/empty-table.e425a16a.jpg";